import styled from '@emotion/styled/macro';

import { EditableStatus } from '../../../UI/EditableStatus/EditableStatus';

export const StyledEditableStatusRenderer = styled(EditableStatus)`
  width: 100%;
`;
